var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from 'react';
import { gbTheme, GBTypography } from '@leapfinance/geebee-component-library';
import { ArrowForwardRounded } from '@mui/icons-material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
import { CircularProgress, IconButton, Menu, MenuItem, ThemeProvider } from '@mui/material';
import PinIcon from '../../geebee/icons/unisetuDashboard/PinIcon';
var BusinessInsightCard = function (_a) {
    var _b;
    var title = _a.title, dataCount = _a.dataCount, filters = _a.filters, moreOptions = _a.moreOptions, isPinned = _a.isPinned, onClick = _a.onClick, footer = _a.footer, footerProps = _a.footerProps, _c = _a.cardType, cardType = _c === void 0 ? 'MORE_ACTION' : _c;
    var _d = __read(React.useState(null), 2), anchorEl = _d[0], setAnchorEl = _d[1];
    var open = Boolean(anchorEl);
    var handleClose = function (event) {
        var _a;
        (_a = event === null || event === void 0 ? void 0 : event.stopPropagation) === null || _a === void 0 ? void 0 : _a.call(event);
        setAnchorEl(null);
    };
    var handleClick = function (event) {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };
    return (React.createElement("div", { role: cardType === 'MORE_ACTION' ? 'button' : 'tab', className: "lfc-p-3 lfc-rounded lfc-bg-white lfc-shadow-unisetu-summarydashboard-business-insight-card lfc-flex lfc-flex-col lfc-items-start lfc-gap-y-2", onClick: function () {
            if (cardType === 'MORE_ACTION') {
                onClick(filters);
            }
        } },
        React.createElement("div", { className: "lfc-flex lfc-justify-between lfc-items-start lfc-w-full" },
            React.createElement("div", { className: "lfc-flex lfc-items-start lfc-gap-x-1" },
                isPinned ? (React.createElement("div", { className: "lfc-p-1" },
                    React.createElement(PinIcon, { className: "lfc-w-4 lfc-h-4" }))) : null,
                React.createElement(GBTypography, { variant: "caption1", className: "lfc-font-semibold", style: { color: gbTheme.palette.grey.A900 } }, title)),
            cardType === 'NEXT_ACTION' ? (React.createElement(IconButton, { className: "lfc-cursor-pointer lfc-p-0", onClick: function () {
                    onClick(filters);
                } },
                React.createElement(ArrowForwardRounded, { className: "lfc-text-gbTokens-primary-500" }))) : (React.createElement(React.Fragment, null,
                ((_b = moreOptions === null || moreOptions === void 0 ? void 0 : moreOptions.length) !== null && _b !== void 0 ? _b : 0) > 0 ? (React.createElement(IconButton, { "aria-label": "more", id: "long-button", "aria-controls": open ? 'long-menu' : undefined, "aria-expanded": open ? 'true' : undefined, "aria-haspopup": "true", onClick: handleClick, className: "lfc-p-0" },
                    React.createElement(MoreVertIcon, null))) : null,
                React.createElement(Menu, { id: "long-menu", MenuListProps: {
                        'aria-labelledby': 'long-button'
                    }, anchorEl: anchorEl, open: open, onClose: handleClose, anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'left'
                    }, transformOrigin: {
                        vertical: 'top',
                        horizontal: 100
                    }, sx: {
                        '.MuiMenuItem-root': {
                            textAlign: 'left',
                            fontFamily: 'Montserrat'
                        }
                    } }, moreOptions === null || moreOptions === void 0 ? void 0 : moreOptions.map(function (item, index) { return (React.createElement(ThemeProvider, { theme: gbTheme, key: index },
                    React.createElement(MenuItem, __assign({}, item.prop, { className: "".concat(item.prop.loading ? 'hover:lfc-bg-primary-100 ' : 'hover:lfc-bg-primary-200 ') }),
                        React.createElement(GBTypography, { variant: "body4", className: "".concat(item.prop.loading ? 'lfc-text-primary-800' : 'lfc-text-primary-600', " ") },
                            item.text,
                            item.prop.loading ? (React.createElement(CircularProgress, { size: '1rem', sx: {
                                    marginLeft: '1rem'
                                } })) : null)))); }))))),
        React.createElement(GBTypography, { variant: "h2", style: { color: gbTheme.palette.grey['900'] } }, dataCount),
        footer && typeof footer === 'string' ? (React.createElement(GBTypography, __assign({ variant: "sh3Regular", className: "lfc-text-gbTokens-primary-500 lfc-underline lfc-cursor-pointer", onClick: footerProps === null || footerProps === void 0 ? void 0 : footerProps.onClick }, footerProps),
            footer,
            React.createElement(OpenInNewRoundedIcon, { className: "lfc-text-xs lfc-ml-1" }))) : (footer || null)));
};
export default BusinessInsightCard;
//# sourceMappingURL=BusinessInsightCard.js.map